import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './style.css';

export default function Success() {
  return (
    <section className="success-section">
      <Container>
        <Row className="justify-content-center">
          <Col md="8">
            <div className="success-content text-center">
              <h1 className="success-title">Tu pago es exitoso</h1>
              <div className="success-description">
                Gracias por tu pago. Se enviará un recibo de pago automático a su correo electrónico registrado.
              </div>
              <div className="success-buttons mt-4">
                <a href="./" className="btn btn-outline-success">
                  Volver a la página principal
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
